import { type ReactNode } from 'react';
import { Skeleton } from '@/components/ui/skeleton';

export function FeedListSkeleton(): ReactNode {
  return (
    <div className="mx-auto max-h-[calc(100dvh-10rem)] w-full max-w-[42rem] space-y-md overflow-hidden">
      {Array.from({ length: 8 }, (_, i) => (
        <Skeleton key={i} className="h-32 w-full rounded-lg sm:h-36" />
      ))}
    </div>
  );
}
